import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { StateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { LoginDetails, AuthDetails, AuthNormalisedEntities } from "../models";
import { User } from "../models";

const actionCreator = actionCreatorFactory.default();

export const requestLogin =  actionCreator<LoginDetails>(actionTypes.LOGIN_REQUEST);
export const loginSuccess =  actionCreator<AuthDetails>(actionTypes.LOGIN_SUCCESS);
export const loginFailure =  actionCreator<StateError>(actionTypes.LOGIN_FAILURE);

export const logout = actionCreator<{}>(actionTypes.LOGOUT);

export const requestUsersIndex = actionCreator<{}>(actionTypes.USER_INDEX_REQUEST);
export const usersIndexSuccess = actionCreator<NormalisedResult<number[], AuthNormalisedEntities>>(
    actionTypes.USER_INDEX_SUCCESS,
);
export const usersIndexFailure = actionCreator<StateError>(actionTypes.USER_INDEX_FAILURE);

export const requestUsersStore = actionCreator<User>(actionTypes.USER_STORE_REQUEST);
export const usersStoreSuccess = actionCreator<User>(actionTypes.USER_STORE_SUCCESS);
export const usersStoreFailure = actionCreator<StateError>(actionTypes.USER_STORE_FAILURE);

export const requestUsersShow = actionCreator<number>(actionTypes.USER_SHOW_REQUEST);
export const usersShowSuccess = actionCreator<NormalisedResult<number, AuthNormalisedEntities>>(
    actionTypes.USER_SHOW_SUCCESS,
);
export const usersShowFailure = actionCreator<StateError>(actionTypes.USER_SHOW_FAILURE);

export const requestUsersUpdate = actionCreator<User>(actionTypes.USER_UPDATE_REQUEST);
export const usersUpdateSuccess = actionCreator<User>(actionTypes.USER_UPDATE_SUCCESS);
export const usersUpdateFailure = actionCreator<StateError>(actionTypes.USER_UPDATE_FAILURE);

export const requestUsersDestroy = actionCreator<number>(actionTypes.USER_DESTROY_REQUEST);
export const usersDestroySuccess = actionCreator<number>(actionTypes.USER_DESTROY_SUCCESS);
export const usersDestroyFailure = actionCreator<StateError>(actionTypes.USER_DESTROY_FAILURE);

export const requestOrganisationsIndex = actionCreator<{}>(
    actionTypes.ORGANISATION_INDEX_REQUEST,
);
export const organisationsIndexSuccess = actionCreator<NormalisedResult<number[], AuthNormalisedEntities>>(
    actionTypes.ORGANISATION_INDEX_SUCCESS,
);
export const organisationsIndexFailure = actionCreator<StateError>(
    actionTypes.ORGANISATION_INDEX_FAILURE,
);

export const requestRolesIndex = actionCreator<{}>(actionTypes.ROLE_INDEX_REQUEST);
export const rolesIndexSuccess = actionCreator<NormalisedResult<string[], AuthNormalisedEntities>>(
    actionTypes.ROLE_INDEX_SUCCESS,
);
export const rolesIndexFailure = actionCreator<StateError>(actionTypes.ROLE_INDEX_FAILURE);

export type AuthAction = Action<LoginDetails> | Action<AuthDetails> | Action<StateError> |
    Action<{}> | Action<User> | Action<NormalisedResult<number[], AuthNormalisedEntities>> |
    Action<NormalisedResult<number, AuthNormalisedEntities>> |
    Action<NormalisedResult<string[], AuthNormalisedEntities>> | Action<number>;
